/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import data from './data';
export default {
  mixins: [data],
  methods: {
    build_quick_filter: function build_quick_filter(filters) {
      var _this = this;

      if (filters) {
        var _filterObj = { 'default': [] };
        var _group = [];
        filters.forEach(function (item) {
          if (item.isGroup === '1') {
            _group.push(item);
            _filterObj[item.id] = [];
          } else if (item.isEnable === '1') {
            var _filter = _filterObj[item.groupId];
            if (!_filter) {
              _filter = _filterObj.default;
            }
            _filter.push(item);
          }
          if (!_this.currentFilter) {
            _this.currentFilter = item.label;
          }
          if (item.isDefault == '1') {
            _this.currentFilter = item.label;
          }
        });
        var filterArr = [];
        if (_group.length > 0) {
          _group.forEach(function (item) {
            var itemArr = _filterObj[item.id];
            if (itemArr.length > 0 && item.isEnable === '1') {
              filterArr.push(itemArr);
            }
          });
        }
        if (_filterObj.default.length > 0) {
          filterArr.push(_filterObj.default);
        }
        this.quickFilter = filterArr;
      }
    },
    change_quick_filter: function change_quick_filter(idx1, idx2, itemLabel) {
      var tempItem = {};
      this.quickFilter[idx1].forEach(function (item, idx) {
        if (idx === idx2) {
          item.isDefault = '1';
          tempItem = item;
        } else {
          item.isDefault = '0';
        }
      });
      this.$emit("quickFilterMethod", tempItem);
      this.query_grid_data(1);
      this.currentFilter = itemLabel;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/mixins/quickFilter.js
// module id = 37
// module chunks = 0